import { Film, Trash2 } from "lucide-react";
import { Link } from "react-router-dom";

import { IconButton, Pill } from "@/components/kit";

const pill = (v) => ({
  label: v.status === "running" || v.status === "queued" ? `${v.progress}%` : v.status === "done" ? "Ready" : "Failed",
  kind: v.status === "done" ? "success" : v.status === "failed" ? "error" : "info",
});

export function VideoList({ videos, onDelete }) {
  const sorted = [...videos].sort((a, b) => (a.created_at < b.created_at ? 1 : -1)); // newest first
  return (
    <section aria-labelledby="videos-heading" className="flex flex-col gap-3" data-testid="videos-section">
      <h2 id="videos-heading" className="text-xl font-medium">Videos</h2>
      {sorted.length === 0 ? <p className="text-[13px] text-muted-foreground" data-testid="videos-empty-text">No videos yet.</p> : null}
      <ul className="grid gap-2 xl:grid-cols-2">
        {sorted.map((v) => (
          <li key={v.id} className="group flex min-h-[76px] items-center gap-3 rounded-xl border border-border bg-card p-2 pr-1 transition-colors hover:border-primary/50"
            data-testid={`video-item-${v.id}`}>
            <Link to={`/renders/${v.id}`} className="focus-ring flex min-w-0 flex-1 items-center gap-3 rounded-lg" data-testid={`video-item-open-${v.id}`}>
              <div className="flex h-[60px] w-[60px] shrink-0 items-center justify-center overflow-hidden rounded-md bg-secondary">
                {v.thumb_url ? <img src={v.thumb_url} alt="" loading="lazy" className="h-full w-full object-cover" /> : <Film className="h-6 w-6 text-muted-foreground" aria-hidden />}
              </div>
              <div className="flex min-w-0 flex-1 flex-col gap-1">
                <p className="text-sm font-medium">{v.format} video</p>
                <p className="truncate text-[13px] text-muted-foreground">{new Date(v.created_at).toLocaleString()}</p>
              </div>
              <Pill {...pill(v)} data-testid={`video-item-status-${v.id}`} />
            </Link>
            <IconButton icon={Trash2} label="Delete video" tint="text-muted-foreground hover:text-destructive" onClick={() => onDelete(v.id)}
              data-testid={`video-delete-${v.id}`} />
          </li>
        ))}
      </ul>
    </section>
  );
}
